import type { SplitViewContentType } from '@saaga/shared/store/slices/split-view.slice'
import type { ReactNode } from 'react'

import { SplitViewContainer } from '@/components/split-view/split-view-container.organism'
import { Sheet, SheetContent } from '@/components/ui/sheet'
import { cn } from '@/lib/utils'

interface MobileLayoutProps {
  children: ReactNode
  isOpen: boolean
  contentType: SplitViewContentType
  contentData: Record<string, unknown> | null
  onClose: () => void
  className?: string
}

export const ChatSplitLayoutMobile: React.FC<MobileLayoutProps> = ({
  children,
  isOpen,
  contentType,
  contentData,
  onClose,
  className,
}): ReactNode => (
  <div className={cn('chat-split-layout chat-split-layout--mobile flex h-full min-h-0', className)}>
    <div className="chat-panel h-full min-h-0 flex-1 overflow-hidden">{children}</div>
    <Sheet open={isOpen} onOpenChange={(open: boolean) => !open && onClose()}>
      <SheetContent side="right" className="split-view-drawer w-full p-0 sm:max-w-lg">
        <SplitViewContainer
          contentType={contentType}
          contentData={contentData}
          onClose={onClose}
          isCloseButtonHidden
        />
      </SheetContent>
    </Sheet>
  </div>
)
